import { inject, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";
import { GlobalsService } from "../services";

export let isOpen: boolean;
let themeUIInitialized = false;

export const themeUI = () => {
  const globals: GlobalsService = inject(GlobalsService);
  const router: Router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  // The app resolver can run more than once. Registering this subscription on
  // every resolve caused Preline to be initialized repeatedly per navigation.
  if (themeUIInitialized) return;
  themeUIInitialized = true;

  router.events.subscribe((event: any) => {
    if (event instanceof NavigationEnd) {
      globals.config.url.next(event.url);

      if (isPlatformBrowser(platformId)) {
        // Wait until Angular has committed the routed component's DOM before
        // asking Preline to discover its data-attribute components.
        requestAnimationFrame(() => {
          (window as any).HSStaticMethods?.autoInit();
        });
      }
    }
  });
}


export const getCSSVariableValue = (variableName: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(variableName);
}


export const scrollToElement = (elementId: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }
}

export const sortObjectsByDate = (array: any[], key: string) => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const todayStr = today.toDateString();
  const yesterdayStr = yesterday.toDateString();

  const todayObjects: any[] = [];
  const yesterdayObjects: any[] = [];
  const otherObjects: any[] = [];

  array.forEach(obj => {
    const date = new Date(obj.date);
    const dateStr = date.toDateString();

    if (dateStr === todayStr) {
      todayObjects.push(obj);
    } else if (dateStr === yesterdayStr) {
      yesterdayObjects.push(obj);
    } else {
      otherObjects.push(obj);
    }
  });

  return {
    today: todayObjects,
    yesterday: yesterdayObjects,
    others: otherObjects
  };
}

export const toogleLivechat = () => {
  if (typeof document === 'undefined') return isOpen;
  if (isOpen) {
    document.body.classList.remove("show-chatbot");
    isOpen = false;
  } else {
    document.body.classList.toggle("show-chatbot");
    isOpen = true;
  }
  return isOpen;
}
